import type { AutomationId } from "../types";

export const AUTOMATION_CONFIG_QUESTIONNAIRE_ID =
  "Questionnaire/clinical-crm-automation-config";

export const AUTOMATION_CONFIG_LINK_IDS = {
  automationType: "automationType",
  messageTemplateId: "messageTemplateId",
} as const;

export const AUTOMATION_ID_TO_TYPE_CODE: Record<AutomationId, string> = {
  triage: "triage",
  preConsultation: "pre-consultation",
  confirmation: "confirmation",
  cancellation: "cancelation",
  payment: "payment",
  postConsultation: "post-consulation",
  birthday: "birthday",
};

export const TYPE_CODE_TO_AUTOMATION_ID: Partial<Record<string, AutomationId>> = {
  triage: "triage",
  "pre-consultation": "preConsultation",
  confirmation: "confirmation",
  cancelation: "cancellation",
  payment: "payment",
  "post-consulation": "postConsultation",
  birthday: "birthday",
};
